import { Component, Input, OnInit } from '@angular/core';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { AirportComment, CommentType } from '../models/airport-comment.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditRemarkComponent } from '../edit-remark/edit-remark.component';
import { DeleteRemarkComponent } from '../delete-remark/delete-remark.component';
import { Airport } from '../models/airport.model';
import { AirportService } from '../airport.service';


/**
 * Remark types that should be displayed in this component
 */
const REMARK_TYPES = [
  CommentType.General,
  CommentType.Facility,
  CommentType.Miscellaneous
];


@Component({
  selector: 'app-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.scss']
})
export class RemarksComponent implements OnInit {
  @Input() airport: Airport;

  editModeSet: boolean;

  constructor( private _toggleService: EditToggleService,
               public _snackBar: MatSnackBar,
               private _editRemarkDialog: MatDialog,
               private _deleteRemarkDialog: MatDialog,
               private _airportService: AirportService) {}

  ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  get additionalRemarks(): Array<AirportComment> {
    return this.airport.airportComments
      .filter(comment => REMARK_TYPES.includes(comment.commentType) && comment.commentRef !== 'WhyHere'
        && comment.text != null && comment.text.toLowerCase().trim() !== 'none')
      .sort((n1, n2) => n1.sourceId - n2.sourceId);
  }

  async reloadAirport(identifier: string) {
    this.airport = await this._airportService.getAirport(identifier, true);
  }

  async openEditRemarkDialog(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    const defaultRemark = {
      commentType: 'General',
      commentRef: 'Notes'
    };
    dialogConfig.data = {
      airID: this.airport.airportId,
      id: null,
      isNew: false,
      remark: defaultRemark
    };
    index == null ? dialogConfig.data.isNew = true : dialogConfig.data.remark = this.additionalRemarks[index];
    dialogConfig.data['airID'] = this.airport.airportId;
    dialogConfig.width = '60%';
    const dialogRef = this._editRemarkDialog.open(EditRemarkComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        if (isUpdated.isNew) {
          this.airport.airportComments.push(isUpdated.remark);
          this._snackBar.open('Remark', 'Added', {
            duration: 2000
          });
        } else {
          this._snackBar.open('Remark', 'Updated', {
            duration: 2000
          });
        }
        this.reloadAirport(this.airport.identifier);
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  deleteRemark(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      airportId: this.airport.airportId,
      remarkId: this.additionalRemarks[index].id
    };
    const dialogRef = this._deleteRemarkDialog.open(DeleteRemarkComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        this._snackBar.open('Remark', 'Deleted', {
          duration: 2000
        });
        // this.airport.airportComments.splice(index, 1);
        this.reloadAirport(this.airport.identifier);
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
